import React from 'react';
import { ArrowRight, ShoppingBag } from 'lucide-react';
import { lifestyleImages } from '../mock';

export const Hero = ({ scrollToSection }) => {
  return (
    <section className="relative bg-gradient-to-br from-gray-50 to-blue-50 overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-40 -right-40 w-96 h-96 bg-yellow-400/10 rounded-full blur-3xl"></div>
        <div className="absolute -bottom-40 -left-40 w-96 h-96 bg-blue-900/10 rounded-full blur-3xl"></div>
      </div>

      <div className="container mx-auto px-4 lg:px-8 py-20 lg:py-32 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Text Content */}
          <div className="text-left space-y-8">
            <div className="inline-block">
              <span className="bg-blue-900 text-white px-4 py-2 rounded-full text-sm font-bold tracking-wide">
                GAFAS OFICIALES DE LA TRI
              </span>
            </div>
            
            <h1 className="text-5xl lg:text-7xl font-black text-gray-900 leading-tight">
              Para vivir cada partido con
              <span className="block mt-2">
                <span className="text-blue-900">estilo</span> y{' '}
                <span className="text-yellow-500">comodidad</span>
              </span>
            </h1>
            
            <p className="text-xl text-gray-700 leading-relaxed max-w-xl">
              Gafas oficiales de La Tri que funcionan igual de bien en el estadio, 
              en un paseo con tus hijos o en vacaciones.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <button 
                onClick={() => scrollToSection('modelos')}
                className="group bg-blue-900 text-white px-8 py-4 rounded-xl font-bold text-lg hover:bg-blue-800 transition-all hover:scale-105 hover:shadow-2xl flex items-center justify-center gap-2"
              >
                Ver colección
                <ArrowRight className="group-hover:translate-x-1 transition-transform" size={20} />
              </button>
              <button 
                onClick={() => scrollToSection('comprar')}
                className="group bg-yellow-400 text-gray-900 px-8 py-4 rounded-xl font-bold text-lg hover:bg-yellow-500 transition-all hover:scale-105 hover:shadow-2xl flex items-center justify-center gap-2"
              >
                <ShoppingBag size={20} />
                Comprar ahora
              </button>
            </div>

            {/* Trust Indicators */}
            <div className="flex items-center gap-6 pt-8 flex-wrap">
              <div className="flex items-center gap-2">
                <svg className="w-5 h-5 text-yellow-500" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                </svg>
                <span className="text-sm font-semibold text-gray-700">Producto Oficial</span>
              </div>
              <div className="flex items-center gap-2">
                <svg className="w-5 h-5 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <span className="text-sm font-semibold text-gray-700">Protección UV400</span>
              </div>
              <div className="flex items-center gap-2">
                <svg className="w-5 h-5 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                <span className="text-sm font-semibold text-gray-700">Envío a todo Ecuador</span>
              </div>
            </div>
          </div>

          {/* Product Images */}
          <div className="relative">
            <div className="relative z-10">
              <img 
                src={lifestyleImages.heroLifestyle} 
                alt="Padre e hijo celebrando con Gafas La Tri" 
                className="rounded-3xl shadow-2xl w-full object-cover aspect-square" loading="eager" fetchpriority="high"
              />
            </div>
            {/* Floating Cards */}
            <div className="absolute -bottom-6 -left-6 bg-white rounded-2xl shadow-xl p-4 z-20 animate-bounce-slow">
              <div className="flex items-center gap-3">
                <div className="bg-green-100 p-2 rounded-lg">
                  <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <div>
                  <div className="text-sm font-bold text-gray-900">Envío Gratis</div>
                  <div className="text-xs text-gray-600">En compras sobre $50</div>
                </div>
              </div>
            </div>
            {/* Hashtag badge */}
            <div className="absolute -top-4 -right-4 z-20 bg-blue-900 text-yellow-400 rounded-2xl shadow-xl px-4 py-3 font-bold">
              #HacerHistoriaConLaTri
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
